"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatReservations = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Sub_1 = require("../../../../../Page/Title/Sub");
const FlightInfoTable_1 = require("../FlightInfoTable");
const SeatNumber_1 = require("../SeatNumber");
require("./index.scss");
const className = 'flight-list-info-seat-reservations';
const CellNumbers = (props) => {
    const { economy, business, } = props;
    return (react_1.default.createElement("div", { className: `${className}__numbers` },
        react_1.default.createElement(SeatNumber_1.SeatNumber, { type: 'economy', seatNumber: economy }),
        react_1.default.createElement(SeatNumber_1.SeatNumber, { type: 'business', seatNumber: business })));
};
const tableColumns = [
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Users', defaultMessage: 'Users' })),
        id: 'user',
        disableSortBy: true,
        Cell: ({ row }) => {
            return row.original.user;
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Limits', defaultMessage: 'Limits' })),
        id: 'limit',
        disableSortBy: true,
        Cell: ({ row }) => {
            const { skipped, business, economy } = row.original.limit;
            if (skipped) {
                return '-';
            }
            return (react_1.default.createElement(CellNumbers, { economy: economy, business: business }));
        },
    },
    {
        Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Booked', defaultMessage: 'Booked' })),
        id: 'booked',
        disableSortBy: true,
        Cell: ({ row }) => {
            const { skipped, business, economy } = row.original.booked;
            if (skipped) {
                return '-';
            }
            return (react_1.default.createElement(CellNumbers, { economy: economy, business: business }));
        },
    },
];
const SeatReservations = (props) => {
    const { business, economy, } = props;
    if (!business || !economy)
        return null;
    const seatsReservationData = [
        {
            user: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:AgentUser', defaultMessage: 'Agents' })),
            limit: {
                economy: economy.agentLimit,
                business: business.agentLimit,
            },
            booked: {
                economy: economy.agentOwnedSeats,
                business: business.agentOwnedSeats,
            },
        },
        {
            user: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:OnlineUser', defaultMessage: 'Online' })),
            limit: {
                economy: economy.onlineLimit,
                business: business.onlineLimit,
            },
            booked: {
                economy: economy.onlineReservedSeats,
                business: business.onlineReservedSeats,
            },
        },
        {
            user: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:MalesiaUser', defaultMessage: 'Malesia' })),
            limit: {
                economy: 0,
                business: 0,
                skipped: true,
            },
            booked: {
                economy: economy.managerReservedSeats - (economy.agentOwnedSeats - economy.agentReservedSeats),
                business: business.managerReservedSeats - (business.agentOwnedSeats - business.agentReservedSeats),
            },
        },
    ];
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'seat', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:SeatReservations', defaultMessage: 'Seat reservations' }), modificators: 'margin-bottom-sm' }),
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: `${className}__totals` },
                react_1.default.createElement("span", { className: `${className}__header` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:TotalSeats', defaultMessage: 'Total seats' }),
                    react_1.default.createElement(CellNumbers, { economy: economy.totalSeats - (economy.allotmentSeats || 0), business: business.totalSeats - (business.allotmentSeats || 0) })),
                react_1.default.createElement("span", { className: `${className}__header` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Adults', defaultMessage: 'Adults' }),
                    react_1.default.createElement(CellNumbers, { economy: economy.adultPassengers, business: business.adultPassengers })),
                react_1.default.createElement("span", { className: `${className}__header` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Children', defaultMessage: 'Children' }),
                    react_1.default.createElement(CellNumbers, { economy: economy.childPassengers, business: business.childPassengers })),
                react_1.default.createElement("span", { className: `${className}__header` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:Babies', defaultMessage: 'Babies' }),
                    react_1.default.createElement(CellNumbers, { economy: economy.infantPassengers, business: business.infantPassengers })),
                react_1.default.createElement("span", { className: `${className}__header` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/List/Info:FreePlaces', defaultMessage: 'Free seats' }),
                    react_1.default.createElement(CellNumbers, { economy: economy.freeSeats, business: business.freeSeats }))),
            react_1.default.createElement(FlightInfoTable_1.FlightInfoTable, { columns: tableColumns, data: seatsReservationData }))));
};
exports.SeatReservations = SeatReservations;
//# sourceMappingURL=index.js.map